import React, { Fragment, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import _ from 'lodash'
import { TextField } from '@material-ui/core'
import { Button } from '@progress/kendo-react-buttons'
import { Grid as KendoGrid, GridColumn as Column } from '@progress/kendo-react-grid'
import { getProjects, getSearchTerm } from '../store/selectors'
import { createNewProject, fetchProjects, setSearchTerm } from '../store/actions'
import { DateCell, Loader, NewProjectDialog } from '../components'
import { Placeholder } from '../components/styled/FormComponents'

export default () => {
    const [status, setStatus] = useState('ready')
    const [skip, setSkip] = useState(0)
    const [take, setTake] = useState(12)
    const [showNewProjectDialog, setShowNewProjectDialog] = useState(false)

    const dispatch = useDispatch()
    const projects = useSelector(getProjects)
    const searchTerm = useSelector(getSearchTerm)
    const history = useHistory()

    const pageChange = (event) => {
        setSkip(event.page.skip)
        setTake(event.page.take)
    }

    const handleOnKeyUp = (e) => {
        if (e.which === 13) {
            setStatus('loading')
            dispatch(setSearchTerm(e.target.value))
            dispatch(fetchProjects(e.target.value))
                .then(() => {
                    setStatus('ready')
                })
        }
    }

    const handleOnClick = (e) => {
        history.push(`/edit/${e.dataItem.id}`)
    }

    const handleShowNewProjectDialog = () => {
        setShowNewProjectDialog(!showNewProjectDialog)
    }

    const handleCreateNewProject = (data) => {
        const { prospectNumber, ...dropdownValues } = data;
        const dropdownParams = _.mapValues(dropdownValues, item => item.id)
        const params = {
            ...dropdownParams,
            prospectNumber
        } 
        dispatch(createNewProject(params))
            .then(data => data.payload)
            .then(({ newId }) => {
                history.push(`/edit/${newId}`)
            })
    }

    return (<Fragment>
        {showNewProjectDialog && <NewProjectDialog
            onClose={handleShowNewProjectDialog}
            onSubmit={handleCreateNewProject}
        />}
        {(status === 'loading') && <Loader/>}
        <StyledButton primary onClick={handleShowNewProjectDialog}>Neues Projekt</StyledButton>
        <TextField label="Suchbegriff" defaultValue={searchTerm} onKeyUp={handleOnKeyUp} />
        <Placeholder/>
        {projects && (status === 'ready') ? <KendoGrid
            data={[...projects].slice(skip, take + skip)}
            skip={skip}
            take={take}
            total={projects.length}
            pageable={true}
            onPageChange={pageChange}
            onRowClick={handleOnClick}
        >
            <Column field="mediaNumber" title="Mediennr. / Prospektnr."/>
            <Column field="title" title="Name" width="450px"/>
            <Column field="inChargeName" title="Sachbearbeiter"/>
            <Column field="edition" title="Auflage"/>
            <Column field="status" title="Nach-/Neudruck" width="250px"/>
            <Column field="printOrderDeliveryDate" cell={DateCell} title="geliefert am"/>
            <Column field="createdAt" cell={DateCell} title="Erstelldatum"/>
        </KendoGrid> : null}
    </Fragment>)
}

const StyledButton = styled(Button)`
    margin: 12px 15px 0 0;
`



// WEBPACK FOOTER //
// ./src/pages/Search.js